import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface BackofficeMpesaConfigDraft {
  bp_mpesa_c2b_consumer_key: string;
  bp_mpesa_c2b_consumer_secret: string;
  bp_mpesa_b2c_consumer_key: string;
  bp_mpesa_b2c_consumer_secret: string;
  bp_mpesa_b2b_consumer_key: string;
  bp_mpesa_b2b_consumer_secret: string;
  bp_mpesa_passkey: string;
  bp_mpesa_c2b_shortcode: string;
  bp_mpesa_c2b_shortcode_type: string;
  bp_mpesa_b2c_shortcode: string;
  bp_mpesa_b2b_shortcode: string;
  bp_mpesa_b2c_initiator_name: string;
  bp_mpesa_b2b_initiator_name: string;
  bp_mpesa_security_credential: string;
  bp_mpesa_b2c_initiator_password: string;
}

export interface BackofficeMpesaConfigFetched {
  _id?: string;
  bp_location_id?: string;
  bp_mpesa_configuration_c2b_shortcode_information?: string;
  bp_mpesa_configuration_c2b_shortcode_type_information?: string;
  bp_mpesa_configuration_b2c_shortcode_information?: string;
  bp_mpesa_configuration_b2b_shortcode_information?: string;
  bp_mpesa_configuration_information_created_at?: string;
  bp_mpesa_configuration_information_updated_at?: string;
}

export interface BackofficeMpesaConfigSliceObject {
  draft: BackofficeMpesaConfigDraft;
  fetched: BackofficeMpesaConfigFetched | null;
}

const initialDraft: BackofficeMpesaConfigDraft = {
  bp_mpesa_c2b_consumer_key: '',
  bp_mpesa_c2b_consumer_secret: '',
  bp_mpesa_b2c_consumer_key: '',
  bp_mpesa_b2c_consumer_secret: '',
  bp_mpesa_b2b_consumer_key: '',
  bp_mpesa_b2b_consumer_secret: '',
  bp_mpesa_passkey: '',
  bp_mpesa_c2b_shortcode: '',
  bp_mpesa_c2b_shortcode_type: '',
  bp_mpesa_b2c_shortcode: '',
  bp_mpesa_b2b_shortcode: '',
  bp_mpesa_b2c_initiator_name: '',
  bp_mpesa_b2b_initiator_name: '',
  bp_mpesa_security_credential: '',
  bp_mpesa_b2c_initiator_password: '',
};

const initialState: BackofficeMpesaConfigSliceObject = {
  draft: initialDraft,
  fetched: null,
};

const mpesaConfigSlice = createSlice({
  name: 'mpesaConfig',
  initialState,
  reducers: {
    setMpesaDraftField: (
      state,
      action: PayloadAction<{
        name: keyof BackofficeMpesaConfigDraft;
        value: string;
      }>,
    ) => {
      const { name, value } = action.payload;
      state.draft[name] = value;
    },
    setMpesaDraft: (
      state,
      action: PayloadAction<Partial<BackofficeMpesaConfigDraft>>,
    ) => {
      state.draft = { ...state.draft, ...(action.payload || {}) };
    },
    resetMpesaDraft: state => {
      state.draft = initialDraft;
    },
    setFetchedMpesaConfig: (
      state,
      action: PayloadAction<BackofficeMpesaConfigFetched | null>,
    ) => {
      state.fetched = action.payload ?? null;
    },
    clearFetchedMpesaConfig: state => {
      state.fetched = null;
    },
  },
});

export const {
  setMpesaDraftField,
  setMpesaDraft,
  resetMpesaDraft,
  setFetchedMpesaConfig,
  clearFetchedMpesaConfig,
} = mpesaConfigSlice.actions;

export default mpesaConfigSlice.reducer;

// Selectors
import type { RootState } from '../types';

export const selectBackofficeMpesaConfigDraft = (state: RootState) =>
  state.backofficeMpesaConfig.draft;

export const selectFetchedMpesaConfig = (state: RootState) =>
  state.backofficeMpesaConfig.fetched;
